import { InjectionToken } from '@angular/core';

export const FES_ERROR_MAP_TOKEN = new InjectionToken<any[]>(
  'FES Error notifications configuration map.'
);

export const FES_SUCCESS_MAP_TOKEN = new InjectionToken<any[]>(
  'FES Success notifications configuration map.'
);
